export default "__VITE_ASSET__CHo_xdNc__"